"use client";

import styled from "styled-components";

export const ParagraphTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  font-family: var(--font-pt-serif);
  font-size: 2rem;
  font-style: normal;
  font-weight: 400;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  line-height: 160%;
  padding: 0.4rem 0.2rem;

  .article-detail-mobile-ui-true & {
    font-size: 1.4rem;
    line-height: 145%;
  }

  @media only screen and (max-width: 768px) {
    font-size: 1.4rem;
    line-height: 145%;
  }
`;
